export default "__VITE_ASSET__D8lDEh8l__"